import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import MesaEntradaService from "../../services/MesaEntradaService";
import { MENU_MESA_ENTRADA, MENU_TIPO_EXPEDIENTE } from "../../utils/constants";
import { armarParametrosMesaEntradaExcel } from "../../helpers/parametros";

// Documentacion
export const cleanDocumentacionMesaEntrada = () => ({ type: types.documentacionMesaEntradaClean });
export const errorDocumentacionMesaEntrada = () => ({ type: types.documentacionMesaEntradaError });
export const getDocumentacionMesaEntrada = (body) => ({ type: types.documentacionMesaEntradaSucces, payload: body });
export const postDocumentacionMesaEntrada = (body) => ({ type: types.documentacionMesaEntradaInsert, payload: body });
export const deleteDocumentacionMesaEntrada = (id) => ({ type: types.documentacionMesaEntradaEliminar, payload: id });


// Actions
export const getDocumentacionComprobante = (idExpediente, ospeDirecto) => 
async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = ospeDirecto ? await MesaEntradaService.getDocumentacionDirecto(idExpediente) : await MesaEntradaService.getDocumentacion(idExpediente);
      const body = await response.json();
      if (response.ok) {
          dispatch(getDocumentacionMesaEntrada(body));
          dispatch(finishSpinner());
      } else {
          throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(errorDocumentacionMesaEntrada());
      handleErrorApi(dispatch, error, "Error al traer documentacion", "Ha ocurrido un error. Intente nuevamente");
    }
}

export const setDocumentacionComprobante = (formData, idTipoDoc, idExpediente) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await MesaEntradaService.postDocumentacion(formData, idTipoDoc, idExpediente, dispatch)
      const body = await response.json();
      if (response.ok) {
        dispatch(postDocumentacionMesaEntrada(body));
        dispatch(
          startAlerta(
            "Datos Guardados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const deleteDocumentoMesaEntrada = (idDocumentacionComprobante) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await MesaEntradaService.deleteDocumentacion(idDocumentacionComprobante)
      const body = await response.json();
      if (response.ok) {
        dispatch(deleteDocumentacionMesaEntrada(idDocumentacionComprobante));
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Documento Eliminado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

export const generateExcelMesaEntrada = (idEfectorFacturacion) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { recepcionMenu, tipoComprobanteDocumentoMenu } = getState().mesaEntrada;
      const menuPrestador = recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR;
      const response = menuPrestador 
        ? await MesaEntradaService.getExcelComprobantesPrestadores(idEfectorFacturacion)
        : await MesaEntradaService.getExcelComprobantesDocumento(tipoComprobanteDocumentoMenu)
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
        let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = menuPrestador ? `ComprobantesPrestadores-MesaEntrada.xlsx` : `ComprobantesDocumentos-MesaEntrada.xlsx`;
        a.click();
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el excel",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }
  
  export const generatePDFMesaEntrada = (idEfectorFacturacion) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { recepcionMenu, tipoComprobanteDocumentoMenu } = getState().mesaEntrada;
      const menuPrestador = recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR;
      const  response = menuPrestador
        ? await MesaEntradaService.getPdfComprobantesPrestadores(idEfectorFacturacion)
        : await MesaEntradaService.getPdfComprobantesDocumento(tipoComprobanteDocumentoMenu)
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
        window.open(URL.createObjectURL(body));
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el pdf",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }

  export const generateExcelMesaEntradaGestion = (idEstado, gestion) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
      const { activeBreadcrumb } = getState().mesaEntrada;
      const parametros = armarParametrosMesaEntradaExcel(gestion.proveedor, gestion.idTipoEfector, gestion.fechaDesde, gestion.fechaHasta, activeBreadcrumb, gestion.tipoComprobanteDocumento, gestion.idSubArea, gestion.idEfectorFacturacion);
      const response = 
        activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES
        ? await MesaEntradaService.getExcelComprobantesGestion(idEstado, parametros) 
        : await MesaEntradaService.getExcelComprobantesDocumentoGestion(idEstado, parametros)
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
        let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = `ComprobantesGestion-MesaEntrada.xlsx`;
        a.click();
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el excel",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }